




































import { Component, Vue, Prop } from 'vue-property-decorator';

@Component<MiPill>({})
export default class MiPill extends Vue {
  @Prop({ default: '' })
  protected label!: string;

  @Prop({ default: false })
  protected clearable!: boolean;

  @Prop({ default: false })
  protected dense!: boolean;

  @Prop({ default: '' })
  protected type!: string;

  @Prop({ default: 'bg-secondary-500' }) protected bgColor!: string;

  @Prop({ default: 'text-white' }) protected textColor!: string;

  @Prop({ default: 'text-secondary-200' }) protected clearColor!: string;

  @Prop({ default: 'text-white' }) protected clearHoverColor!: string;

  protected temp = '';

  protected clear(): void {
    this.$emit('clear');
  }
}
